import script from "./ChangeAdt.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeAdt.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeAdt.vue?vue&type=style&index=0&id=378ee0e4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378ee0e4"]])

export default __exports__